export const fontsName = {
	BNazanin: 'BNazanin',
	BNazaninBold: 'BNazaninBold',
	BTitrBold: 'BTitrBold',
	PersianRoya: 'Persian-Roya',
	PersianRoyaBold: 'Persian-Roya-Bold',
	IranianSans: 'Iranian-Sans',
	Vazir: 'Vazir',
	VazirThin: 'Vazir-Thin',
	VazirMedium: 'Vazir-Medium',
	VazirLight: 'Vazir-Light',
	VazirBold: 'Vazir-Bold',
	VazirBlack: 'Vazir-Black',
	Shabnam: 'Shabnam',
	ShabnamThin: 'Shabnam-Thin',
	ShabnamMedium: 'Shabnam-Medium',
	ShabnamLight: 'Shabnam-Light',
	ShabnamBold: 'Shabnam-Bold',
	Yekan: 'Yekan',
};
